var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{class:{ listWithImage: _vm.withImage }},_vm._l((_vm.models),function(model){return _c('model-list-item',_vm._b({key:model.id,attrs:{"withImage":_vm.withImage}},'model-list-item',model,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }